import React, { memo } from 'react';
import { Row, Cell, Loading } from '@dexma/ui-components';
import { StyledPanelDataSet } from 'adapter/in/dashboards/pages/EditDashboard/WidgetMenu/Panel/DataSet/style';

const PanelDataSet = () => (
    <StyledPanelDataSet fluid data-testid='panel-data-set'>
        <Row alignItems='start'>
            <Cell className='data-set-content'>
                <Loading isLoading size={50} />
            </Cell>
        </Row>
    </StyledPanelDataSet>
);

export default memo(PanelDataSet);
